var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SellHeader',{attrs:{"img_header":_vm.header_image,"header":"คำสั่งซื้อ","link_back":_vm.link_back}}),_c('Confirm_partner_edit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }